module.exports = __webpack_public_path__ + "img/bg7.7044e491.png";